/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IAdmission } from 'app/shared/model/admission.model';

export interface IAtendant {
  id?: string;
  phone?: string;
  name?: string;
  orderOfPriority?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  glucoUser?: IGlucoUser | null;
  admission?: IAdmission | null;
}

export const defaultValue: Readonly<IAtendant> = {
  active: false,
};
